/**
 * Helper functions localstorage.js
 *
 * @namespace arrays
 * @date
 * @author
 * @copyright UniWeb bvba 2024
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/localstorage.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export const registeredLocalStorageVariables = {};

export function registerLocalStorageVariable(
  variableKey,
  {storeLoader, serializer, deserializer}
) {
  if (Object.prototype.hasOwnProperty.call(registeredLocalStorageVariables, variableKey)) {
    throw new Error('storage key: ' + variableKey + ' already in use');
  }

  registeredLocalStorageVariables[variableKey] = {storeLoader, serializer, deserializer};
}

export function storeLocalStorageVariable(variableKey, value) {
  checkvariableKey(variableKey);

  if (registeredLocalStorageVariables[variableKey].serializer) {
    value = registeredLocalStorageVariables[variableKey].serializer(value);
  }

  window.localStorage.setItem(variableKey, value)
}

export function retrieveLocalStorageVariable(variableKey) {
  checkvariableKey(variableKey);

  let value = window.localStorage.getItem(variableKey)

  if (value === null) {
    return; // return undefined, local storage variable does not exist.
  }

  if (registeredLocalStorageVariables[variableKey].deserializer) {
    value = registeredLocalStorageVariables[variableKey].deserializer(value);
  }

  return value;
}

export function loadLocalStorageVariableIntoStore(variableKey, store) {
  const value = retrieveLocalStorageVariable(variableKey);

  if (typeof value === 'undefined') {
    return;
  }

  if (registeredLocalStorageVariables[variableKey].storeLoader) {
    registeredLocalStorageVariables[variableKey].storeLoader(value, store);
  }
}

function checkvariableKey(variableKey) {
  if (!Object.prototype.hasOwnProperty.call(registeredLocalStorageVariables, variableKey)) {
    throw new Error(`variableKey ${variableKey} not registered, use registerLocalStorageRetrieval first for ${variableKey}`);
  }

  if (!window.localStorage) {
    throw new Error('local storage not available');
  }
}
